import { Layout } from '@/utils/routerHelper'

// 店铺管理
export default {
  path: '/store',
  redirect: '/store/type',
  component: Layout,
  name: 'Store',
  meta: {
    title: '店铺管理',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'type',
      name: 'StoreType',
      component: () => import('@/views/Store/StoreType/Index.vue'),
      meta: {
        title: '店铺类型管理'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreType/Detail/Index.vue'),
          name: 'StoreTypeDetail',
          meta: {
            title: '店铺类型详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/type'
          }
        }
      ]
    },
    {
      path: 'typeAudit',
      name: 'StoreTypeAudit',
      component: () => import('@/views/Store/StoreTypeAudit/Index.vue'),
      meta: {
        title: '店铺类型审核'
      }
    },
    {
      path: 'info',
      name: 'StoreInfo',
      component: () => import('@/views/Store/StoreInfo/Index.vue'),
      meta: {
        title: '店铺信息管理'
      },
      children: [
        {
          path: 'add',
          component: () => import('@/views/Store/StoreInfo/Add/Index.vue'),
          name: 'StoreInfoAdd',
          meta: {
            title: '申请开业',
            hidden: true,
            canTo: true,
            activeMenu: '/store/info'
          }
        },
        {
          path: 'companyAudit',
          component: () => import('@/views/Store/StoreInfo/CompanyAudit/Index.vue'),
          name: 'StoreInfoCompanyAudit',
          meta: {
            title: '申请开店',
            hidden: true,
            canTo: true,
            activeMenu: '/store/info'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreInfo/Detail/Index.vue'),
          name: 'StoreInfoDetail',
          meta: {
            title: '查看',
            hidden: true,
            canTo: true,
            activeMenu: '/store/info'
          }
        },
        {
          path: 'conversionRecord',
          component: () => import('@/views/Store/StoreInfo/ConversionRecord/Index.vue'),
          name: 'StoreInfoConversionRecord',
          meta: {
            title: '转换记录',
            hidden: true,
            canTo: true,
            activeMenu: '/store/info'
          },
          children: [
            {
              path: 'detail',
              component: () => import('@/views/Store/StoreInfo/ConversionRecord/Detail/Index.vue'),
              name: 'StoreInfoConversionRecordDetail',
              meta: {
                title: '实体店查看详情',
                hidden: true,
                canTo: true,
                activeMenu: '/store/info'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'addressChangeAudit',
      name: 'StoreAddressChangeAudit',
      component: () => import('@/views/Store/StoreAddressChangeAudit/Index.vue'),
      meta: {
        title: '店铺地址变更审核'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreAddressChangeAudit/Detail/Index.vue'),
          name: 'StoreAddressChangeAuditDetail',
          meta: {
            title: '查看',
            hidden: true,
            canTo: true,
            activeMenu: '/store/addressChangeAudit'
          }
        },
        {
          path: 'audit',
          component: () => import('@/views/Store/StoreAddressChangeAudit/Audit/Index.vue'),
          name: 'StoreAddressChangeAuditAudit',
          meta: {
            title: '公司审核',
            hidden: true,
            canTo: true,
            activeMenu: '/store/addressChangeAudit'
          }
        },
        {
          path: 'apply',
          component: () => import('@/views/Store/StoreAddressChangeAudit/Apply/Index.vue'),
          name: 'StoreAddressChangeAuditApply',
          meta: {
            title: '申请地址变更',
            hidden: true,
            canTo: true,
            activeMenu: '/store/addressChangeAudit'
          }
        }
      ]
    },
    {
      path: 'whiteList',
      name: 'StoreWhiteList',
      component: () => import('@/views/Store/StoreWhiteList/Index.vue'),
      meta: {
        title: '店铺白名单管理'
      }
    },
    {
      path: 'whiteListAudit',
      name: 'StoreWhiteListAudit',
      component: () => import('@/views/Store/StoreWhiteListAudit/Index.vue'),
      meta: {
        title: '店铺白名单审核'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreWhiteListAudit/Detail/Index.vue'),
          name: 'StoreWhiteListAuditDetail',
          meta: {
            title: '详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/whiteListAudit'
          }
        }
      ]
    },
    {
      path: 'nayiOpenApply',
      name: 'NayiOpenApply',
      component: () => import('@/views/Store/NayiOpenApplyList/Index.vue'),
      meta: {
        title: '纳宜开店申请列表'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/NayiOpenApplyList/Detail/Index.vue'),
          name: 'NayiOpenApplyDetail',
          meta: {
            title: '查看详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/nayiOpenApply'
          }
        },
        {
          path: 'audit',
          component: () => import('@/views/Store/NayiOpenApplyList/Audit/Index.vue'),
          name: 'NayiOpenApplyAudit',
          meta: {
            title: '审核',
            hidden: true,
            canTo: true,
            activeMenu: '/store/nayiOpenApply'
          }
        }
      ]
    },
    {
      path: 'licenseChangeAudit',
      name: 'StoreLicenseChangeAudit',
      component: () => import('@/views/Store/StoreLicenseChangeAudit/Index.vue'),
      meta: {
        title: '店铺证件照变更审核'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreLicenseChangeAudit/Detail/Index.vue'),
          name: 'StoreLicenseChangeAuditDetail',
          meta: {
            title: '查看详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/licenseChangeAudit'
          }
        },
        {
          path: 'audit',
          component: () => import('@/views/Store/StoreLicenseChangeAudit/Audit/Index.vue'),
          name: 'StoreLicenseChangeAuditAudit',
          meta: {
            title: '公司审核',
            hidden: true,
            canTo: true,
            activeMenu: '/store/licenseChangeAudit'
          }
        },
        {
          path: 'apply',
          component: () => import('@/views/Store/StoreLicenseChangeAudit/Apply/Index.vue'),
          name: 'StoreLicenseChangeAuditApply',
          meta: {
            title: '申请证照变更',
            hidden: true,
            canTo: true,
            activeMenu: '/store/licenseChangeAudit'
          }
        }
      ]
    },
    {
      path: 'suspensionAudit',
      name: 'StoreSuspensionAudit',
      component: () => import('@/views/Store/StoreSuspensionAudit/Index.vue'),
      meta: {
        title: '店铺停业审核'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreSuspensionAudit/Detail/Index.vue'),
          name: 'StoreSuspensionAuditDetail',
          meta: {
            title: '查看详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/suspensionAudit'
          }
        },
        {
          path: 'audit',
          component: () => import('@/views/Store/StoreSuspensionAudit/Audit/Index.vue'),
          name: 'StoreSuspensionAuditAudit',
          meta: {
            title: '停业审核',
            hidden: true,
            canTo: true,
            activeMenu: '/store/suspensionAudit'
          }
        },
        {
          path: 'apply',
          component: () => import('@/views/Store/StoreSuspensionAudit/Apply/Index.vue'),
          name: 'StoreSuspensionAuditApply',
          meta: {
            title: '停业申请',
            hidden: true,
            canTo: true,
            activeMenu: '/store/suspensionAudit'
          }
        }
      ]
    },
    {
      path: 'transferAudit',
      name: 'StoreTransferAudit',
      component: () => import('@/views/Store/StoreTransferAudit/Index.vue'),
      meta: {
        title: '店铺转让审核'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreTransferAudit/Detail/Index.vue'),
          name: 'StoreTransferAuditDetail',
          meta: {
            title: '查看详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/transferAudit'
          }
        },
        {
          path: 'apply',
          component: () => import('@/views/Store/StoreTransferAudit/Apply/Index.vue'),
          name: 'StoreTransferAuditApply',
          meta: {
            title: '转让申请',
            hidden: true,
            canTo: true,
            activeMenu: '/store/transferAudit'
          }
        }
      ]
    },
    {
      path: 'freezeAudit',
      name: 'StoreFreezeAudit',
      component: () => import('@/views/Store/StoreFreezeAudit/Index.vue'),
      meta: {
        title: '店铺冻结/解冻审核'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Store/StoreFreezeAudit/Detail/Index.vue'),
          name: 'StoreFreezeAuditDetail',
          meta: {
            title: '查看详情',
            hidden: true,
            canTo: true,
            activeMenu: '/store/freezeAudit'
          }
        },
        {
          path: 'audit',
          component: () => import('@/views/Store/StoreFreezeAudit/Audit/Index.vue'),
          name: 'StoreFreezeAuditAudit',
          meta: {
            title: '审核',
            hidden: true,
            canTo: true,
            activeMenu: '/store/freezeAudit'
          }
        },
        {
          path: 'apply',
          component: () => import('@/views/Store/StoreFreezeAudit/Apply/Index.vue'),
          name: 'StoreFreezeAuditApply',
          meta: {
            title: '申请冻结/解冻',
            hidden: true,
            canTo: true,
            activeMenu: '/store/freezeAudit'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
